import uuid from 'uuid-random';
import { LAYER } from 'js/components/common/PopupManager';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

const jumioVerifyPopupId = uuid();

export const showJumioVerifyPopupAction = ({ content, onAccept }) => showConfirmationPopupAction({
    id: jumioVerifyPopupId,
    layer: LAYER.JUMIO,
    addFirst: true,
    isModal: true,
    title: 'playtech.mobile.system.jumio.title',
    content,
    onAccept,
    className: 'jumio-verify-popup',
    acceptBtnText: 'playtech.mobile.system.jumio.now',
    declineBtnText: 'playtech.mobile.system.jumio.later'
});

export const showJumioVerifyStatusPopupAction = ({ status }) => showCommonPopupAction({
    className: 'jumio-verify-status-popup',
    title: 'playtech.mobile.system.jumio.title',
    content: `playtech.mobile.system.jumio.${status}`
});
